// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xW9R","title":"styles_title__-Xw3a"};